import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type HttpErrorServiceEvent = { action?: 'suppress' | 'override'; message?: string };

@Injectable()
export class HttpErrorService {
	public watcher$ = new BehaviorSubject<HttpErrorServiceEvent>({});

	suppressDefaultError(): void {
		this.watcher$.next({ action: 'suppress' });
	}

	overrideDefaultErrorMessage(message: string): void {
		this.watcher$.next({ action: 'override', message });
	}
}
